import template from 'templates/unitTestFirmwareView.jst.html'

/**
 * defa.views.UnitTestFirmwareView
 * A simple view for showing progress on firmware updates.
 * @version 1.2.0
 */
const UnitTestFirmwareView = Mn.View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	modelEvents: {
		'change:transientFirmware': 'render',
	},
	
	templateContext: function () {
		return {
			error   : this.error,
			firmware: this.model.get( 'transientFirmware' ),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	failed: function () {
		this.error = true;
		this.render();
	},
	
} );

export default UnitTestFirmwareView;